import { FormControl, FormHelperText, InputLabel, Select } from '@mui/material';
import { isUndefined } from 'lodash';
import React, { Fragment } from 'react';
import ErrorLabel from './ErrorLabel';

const CustomSelect = (props) => {
  const {
    id,
    name,
    label,
    data,
    value,
    margin = 'normal',
    size = 'small',
    onChange,
    textExtractor,
    valueExtractor,
    error,
    errorsHandler,
    disabled,
    readOnly,
    helperText,
    required,
    className,
    height = 30,
  } = props || {};
  const errorMessage = error?.[id];
  const hasError = !isUndefined(errorMessage);

  const errorRemovalHandler = () => {
    errorsHandler((prevError) => {
      delete prevError[id];
      return prevError;
    });
  };

  return (
    <Fragment>
      <FormControl fullWidth margin={margin} className={className}>
        <InputLabel required={!!required} id={id} error={hasError} shrink>
          {label}
        </InputLabel>
        <Select
          native
          required={!!required}
          name={name}
          labelId={id}
          label={label}
          value={value || ''}
          onChange={(e) => {
            onChange(e);
            hasError && errorRemovalHandler();
          }}
          size={size}
          error={hasError}
          disabled={!!disabled}
          readOnly={!!readOnly}
          style={{ height }}
          notched
        >
          {data?.map((item, key) => (
            <option key={`${key}_${id}`} value={valueExtractor(item)}>
              {textExtractor(item) || ''}
            </option>
          ))}
        </Select>
        {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
      <ErrorLabel error={errorMessage} />
    </Fragment>
  );
};

export default CustomSelect;
